import React from 'react'
import MaskedInput from 'react-text-mask'
export const CodigoArtigoField = ({ inputRef, ...rest }) => {
  return (
    <MaskedInput
      {...rest}
      style={{ textTransform: 'uppercase' }}
      mask={[
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/
      ]}
      placeholderChar={'\u2000'}
    />
  )
}

export default CodigoArtigoField



// WEBPACK FOOTER //
// ./src/components/Fields/CodigoArtigoField.js